import styles from "./NotificationItem.module.css";
import {format} from 'date-fns';
import { useNavigate } from 'react-router-dom';

export const NotificationItem = ({id, subject, messageTextValue, createOn, isRead  })  => {

    const navigate = useNavigate()

    const onClickHundler = () => {
        navigate(`/notifications/${id}`)
    }

    return (
        <div className={`${styles.message} ${isRead ? styles.read : styles.unread}`} onClick={onClickHundler}>
          <div className={styles.messageHeader}>
            <span className={styles.messageSubject}>{subject}</span>
            <span className={styles.messageDate}>{format(new Date(createOn), 'dd.MM.yyyy HH:mm:ss')}</span>
          </div>
          <div className={styles.messageContent}>
            {messageTextValue !== null ? messageTextValue.length > 100 ? `${messageTextValue.slice(0, 100)}...` : messageTextValue : null}
          </div>
          <div className={styles.messageFooter}>
          </div>
        </div>
      );
}